
export const config = {
    modelName: 'personal-area',
    formName: 'rejection-appeal'
}